/**
 * Created by Denis Kuzin on 22 august 2025
 */

LightningRushWindow = cc.Node.extend({
    ctor: function (...args) {
        this._super();

        this._windowArgs = args;
        const bundles = ["lightning_rush_window"];
        ComponentMap.attach(this, new WindowComponent(bundles));
    },

    onWindowLoaded: function (mission) {
        this.withShadow = true;

        this.mission = mission;
        this.name = `${mission.getName()}_missionwindow`;

        const closeWindowCallback = () => {
            ComponentMap.get(this, WindowComponent).closeWindow();
        };

        const controller = this.controller = new AisensiaMissionWindowController({ mission, closeWindowCallback });
        ComponentMap.attach(this, controller);

        this.resizable = new Resizable({
            createHorizontalView: function () {
                return new LightningRushHorizontal(controller, { closeWindowCallback });
            },
            createVerticalView: function () {
                return new LightningRushVertical(controller, { closeWindowCallback });
            }
        });
        ComponentMap.attach(this, this.resizable);

        this.onResize();

        this.mission.updateCompetitionResults();
    },

    onResize: function () {
        const sceneSize = cleverapps.resolution.getSceneSize();
        this.setContentSize(sceneSize.width, sceneSize.height);
        this.setPosition(sceneSize.width / 2, sceneSize.height / 2);

        if (this.resizable) {
            this.resizable.onResize();
        }
    }
});
